module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_12-915f5f9990f73d41c483fa4a29ce4832.png";